<template>
    <main>
      <footer
        class="bg-[#151515] text-white"
      >
        <div class="py-8 md:px-12 p-4 max-w-screen-2xl mx-auto ">
        <!-- Logo implementation -->
          <div class="flex justify-center items-center mt-4 mb-14">
            <img src="../assets/images/BM_White White.svg" alt="Barka logo" class="h-8 md:h-12">
          </div>
          <div class="flex flex-wrap justify-between">
            <!-- Quick Links -->
            <div class="w-full lg:w-1/4 mb-6 lg:mb-0">
                <h5 class="font-bold mb-4">Quick Links</h5>
              <ul>
                <li><a href="#" class="hover:text-blue text-2xl transition-all duration-300">Mshel Homes</a></li>
                <li><a href="#" class="hover:text-blue text-2xl transition-all duration-300">Lisa Suites</a></li>
              </ul>
            </div>

            <!-- Resources -->
            <div class="w-full lg:w-1/4 mb-6 lg:mb-0">
              <h5 class="font-bold mb-4">Resources</h5>
              <ul>
                <li><a href="#" class="hover:text-blue text-2xl transition-all duration-300">Articles</a></li>
                <li><a href="#" class="hover:text-blue text-2xl transition-all duration-300">Toolkit</a></li>
                <li><a href="#" class="hover:text-blue text-2xl transition-all duration-300">Videos</a></li>
              </ul>
            </div>

            <!-- Information -->
            <div class="w-full lg:w-1/4 mb-6 lg:mb-0">
              <h5 class="font-bold mb-4">Information</h5>
              <ul>
                <li><a href="#" class="hover:text-blue text-2xl transition-all duration-300">Privacy Policy</a></li>
                <li><a href="#" class="hover:text-blue text-2xl transition-all duration-300">Cookie Policy</a></li>
                <li><a href="#" class="hover:text-blue text-2xl transition-all duration-300">Terms and Condition</a></li>
                <li><a href="#" class="hover:text-blue text-2xl transition-all duration-300">Return & Refund Policy</a></li>
                <li><a href="#" class="hover:text-blue text-2xl transition-all duration-300">Media Release Policy</a></li>
              </ul>
            </div>

            <!-- Contact -->
            <div class="w-full lg:w-1/4">
              <h5 class="font-bold mb-4">Contact</h5>
              <ul>
                <li><a href="#">info@barkamshelia.com</a></li>
                <li><a href="#">+234 706 877 7793</a></li>
              </ul>
              <div class="flex space-x-4 mb-4 mt-4">
                <a href="#" class=" hover:text-blue transition-all duration-300"><i class="fa-brands fa-facebook-f"></i></a>
                <a href="#" class=" hover:text-blue transition-all duration-300"><i class="fa-brands fa-instagram"></i></a>
                <a href="#" class=" hover:text-blue transition-all duration-300"><i class="fa-brands fa-youtube"></i></a>
                <a href="#" class=" hover:text-blue transition-all duration-300"><i class="fa-brands fa-linkedin-in"></i></a>
                <a href="#" class=" hover:text-blue transition-all duration-300"><i class="fa-brands fa-telegram"></i></a>
              </div>
            </div>
          </div>
        </div>
        <div class="border-b border-[#f0f0f0] opacity-30"></div>
        <div class="bg-custom-blue-dark text-center">
          <p class="text-sm mt-1">Copyrights 2024 Barka Mshelia. All Rights Reserved</p>
        </div>
      </footer>
    </main>
  </template>
  
  <script>
  export default {
    name: "FooterSection",
  };
  </script>

  <style scoped>
    .text-sm{
      font-size: 10px !important;
    }
  </style>
  